import React, {useState} from 'react';
import './Input.scss';
import {EyeIcon, EyeOff} from 'lucide-react'

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
    title: string;
    file?: boolean;
    accept?: string;
}

const Input = ({title, file, accept, ...props}: IProps) => {

    const [show, setShow] = useState(false);

    return (
        <label id={props.type} className="label">
            {
                file && <span>{title}</span>
            }

            <div className="row">

                <input  {...props} type={show ? 'text' : props.type}
                       accept={accept}
                       placeholder={title}/>

                {
                    props.type === 'password' ? <div className="showPassword">
                        {
                            show ?
                                <EyeOff color={'var(--grey)'} size={20} onClick={() => setShow(prevState => !prevState)}
                                        cursor={'pointer'}/>
                                :
                                <EyeIcon color={'var(--grey)'} size={20}
                                         onClick={() => setShow(prevState => !prevState)} cursor={'pointer'}/>
                        }
                    </div> : ''
                }

            </div>

        </label>
    );
};

export default Input;
